export const MOONEY_REDIRECT_BACK_URL_QUERY_PARAM = 'url_redirect'
export const MOONEY_HMAC_QUERY_PARAM = 'signature'
export const MOONEY_CHALLANGE_CODE_QUERY_PARAM = 'code_challenge'
export const MOONEY_AUTHORIZATION_CODE_QUERY_PARAM = 'code'
